import Steps from 'rc-steps';
import 'rc-steps/assets/index.css';
import styled from 'styled-components';
import theme from '../../theme';

export default styled(Steps)`
  .rc-steps-item-process .rc-steps-item-icon {
    background: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }
  .rc-steps-item-finish .rc-steps-item-icon {
    background: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }
  
  .rc-steps-item-wait .rc-steps-item-icon {
    background: ${theme.colors.medium};
    border-color: ${theme.colors.medium};
    color: ${theme.colors.white};
  }
  
  .rc-steps-item-process .rc-steps-item-title {
    color: inherit;
  }
  
  .rc-steps-item-finish .rc-steps-item-title {
    color: inherit;
    opacity: 0.4;
  }
  
  .rc-steps-item-wait .rc-steps-item-title {
    color: inherit;
    opacity: 0.4;
  }
  
  .rc-steps-item-title {
    font-size: ${theme.fontSizes.default}
  }
  
  .rc-steps-item-finish .rc-steps-item-title:after {
    background: ${theme.colors.white}
  }

`;
